import { useEffect, useState } from 'react';
import { IConfig, TInitParams } from '../../types';
import { getParameters } from '../../api';
import { ECardType } from '../../utils';
import { FieldViewProps } from '../../page/types';

type UseInitPayFieldProps = {
  session: string,
  payPage: string,
  clientId: string,
  libVersion: string,
};

export const useInitPayField = ({
  session, payPage, clientId, libVersion,
}: UseInitPayFieldProps): FieldViewProps & { isInit: boolean } => {
  const [isInit, setIsInit] = useState(false);
  const [data, setData] = useState<Partial<IConfig>>({});
  const [potentialCardType, setPotentialCardType] = useState<ECardType | null>(data?.preffiledCardType || null);
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    if (!libVersion) return;

    const fetchData = async ({ session, payPage, clientId, libVersion }: TInitParams) => {
      try {
        if (!session || !payPage || !clientId) {
          throw new Error('Missing parameters');
        }

        const response = await getParameters({
          session,
          payPage,
          clientId,
          libVersion,
        });
        if (!response) {
          throw new Error('Network response was not ok');
        }
        const data = { ...response };
        const {
          info,
          paymentMethod: paymentMethods,
        } = response;

        if (info) {
          throw new Error(info);
        }

        if (paymentMethods?.credit?.length) {
          data.paymentMethod.credit = paymentMethods.credit.map((el) =>
            el.replaceAll('"', ''),
          );
        }

        setData(data);
        setPotentialCardType(data?.preffiledCardType || null);
      } catch (error) {
        console.warn(error as Error);
        setError(error);
      } finally {
        setIsInit(true);
      }
    };

    fetchData({
      session,
      payPage,
      clientId,
      libVersion,
    });
  }, [libVersion]);

  return { isInit, data, error, setData, potentialCardType, setPotentialCardType };
};
